import { LocalidadeAPI } from "@/api/localidade.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Localidade } from "@/models/localidade";

const localidadeApi = new LocalidadeAPI();

const getAll = (): AxiosObservable<Localidade[]> => {
  return localidadeApi.getAll();
};

const findAll = (): AxiosObservable<Localidade[]> => {
  return localidadeApi.findAll();
};

export default {
  getAll,
  findAll
};
